export const eventTypes = {
    // Events we produce
    VENUE_CLICK: 'evelin:productInfo:venueClick',
    VENUES_MAP_CLICK: 'evelin:productInfo:venuesMapClick',
    RATINGS_CLICK: 'evelin:buybox:ratingsClick',

    // Events we consume
    BUYBOX_RATINGS_CLICK: 'evelin:buybox:ratingsClick',
    PURCHASE_TYPE_CHANGE: 'evelin:buybox:purchaseTypeChange',

    NAVIGATE_CART: 'evelin:navigate:cart',
};
